import React, {Component} from 'react'

class TableHead extends Component {

    render() {
        return (
            <thead className="TableHead">
                <tr>
                    <th className="PackageName">Package Name</th>
                    <th className="TrackingNumber">Tracking Number</th>
                    <th className="BarcodeNumber">Barcode Number</th>
                    <th className="ShippingAt">Shipped At</th>
                    <th className="CustomerName">Customer Name</th>
                    <th className="Address1">Address 1</th>
                    <th className="Address2">Address 2</th>
                    <th className="City">City</th>
                    <th className="PostalCode">Postal Code</th>
                    <th className="State">State</th>
                    <th className="Country">Country</th>
                    <th className="Type">Type</th>
                    <th className="Weight">Weight</th>
                    <th className="IOSS">IOSS</th>
                    <th className="Box">Box</th>
                    <th className="Source">Source</th>
                </tr>
            </thead>
        )
    }
}

export default TableHead
